import React, { useState } from "react";
import * as XLSX from "xlsx";
import "./BecConfXyTable.css";

const BecConfXyTable = ({
  markers = [],
  onAddRow,
  onUpdateMarker,
  onDeleteMarker,
}) => {
  const [editingId, setEditingId] = useState(null);
  const [editingField, setEditingField] = useState("");
  const [editValue, setEditValue] = useState("");
  const [originalValue, setOriginalValue] = useState("");

  const handleEdit = (id, field, value) => {
    setEditingId(id);
    setEditingField(field);
    const stringValue =
      value !== null && value !== undefined ? String(value) : "";
    setEditValue(stringValue);
    setOriginalValue(stringValue);
  };

  const handleSave = (id) => {
    if (!onUpdateMarker) return;
    onUpdateMarker(id, editingField, editValue);
    setEditingId(null);
    setEditingField("");
    setEditValue("");
  };

  const handleCancel = () => {
    setEditingId(null);
    setEditingField("");
    setEditValue(originalValue);
  };

  const handleChange = (e) => {
    setEditValue(e.target.value);
  };

  const handleKeyDown = (e, id) => {
    if (e.key === "Enter") {
      handleSave(id);
    } else if (e.key === "Escape") {
      handleCancel();
    }
  };

  const handleAddRow = () => {
    if (onAddRow) {
      onAddRow();
    }
  };

  const handleDownload = () => {
    const tableData = markers.map((marker) => ({
      bec_id: marker.id,
      bec_floor_id: marker.bec_floor_id,
      bex_pt_map_x: marker.bex_pt_map_X,
      bex_pt_map_y: marker.bex_pt_map_Y,
    }));
    const worksheet = XLSX.utils.json_to_sheet(tableData);
    const workbook = XLSX.utils.book_new();
    XLSX.utils.book_append_sheet(workbook, worksheet, "bec_conf_xy");
    XLSX.writeFile(workbook, "bec_conf_xy.xlsx");
  };

  if (!markers || markers.length === 0) {
    return (
      <div className="becconf-table-empty">
        <p>No beacons plotted yet. Click on the image to add beacons.</p>
      </div>
    );
  }

  return (
    <div className="becconf-table-container">
      <div className="becconf-table-scroll">
      <div className="becconf-table-header">
        <h3 className="becconf-table-title">Bec conf. xy Table</h3>
        <div className="becconf-table-actions">
          <button
            onClick={handleAddRow}
            className="add-row-btn"
            title="Add New Row"
          >
            <span className="icon-plus" /> Add Row
          </button>
          <button
            onClick={handleDownload}
            className="download-excel-btn"
            title="Download as Excel"
          >
            <span className="icon-download" />
          </button>
        </div>
      </div>
      
        <table className="becconf-table">
          <thead>
            <tr>
              <th>bec_id</th>
              <th>bec_floor_id</th>
              <th>bex_pt_map_x</th>
              <th>bex_pt_map_y</th>
              <th>Actions</th>
            </tr>
          </thead>
          <tbody>
            {markers.map((marker) => (
              <tr key={marker.id} className="becconf-table-row">
                {["id", "bec_floor_id", "bex_pt_map_X", "bex_pt_map_Y"].map(
                  (field) => (
                    <td key={field} className="becconf-table-cell">
                      {editingId === marker.id && editingField === field ? (
                        <input
                          type={
                            ["bex_pt_map_X", "bex_pt_map_Y"].includes(field)
                              ? "number"
                              : "text"
                          }
                          value={editValue}
                          onChange={handleChange}
                          onKeyDown={(e) => handleKeyDown(e, marker.id)}
                          className="cell-input"
                          autoFocus
                          data-marker-id={marker.id}
                          data-field={field}
                        />
                      ) : (
                        <span
                          onClick={() =>
                            handleEdit(
                              marker.id,
                              field,
                              marker[field] === null ||
                                marker[field] === undefined
                                ? ""
                                : marker[field]
                            )
                          }
                          className="cell-value"
                        >
                          {marker[field] === null || marker[field] === undefined
                            ? ""
                            : marker[field]}
                        </span>
                      )}
                    </td>
                  )
                )}
                <td className="becconf-table-actions-cell">
                  {editingId === marker.id ? (
                    <div className="action-group">
                      <button
                        onClick={() => handleSave(marker.id)}
                        className="action-btn save"
                        title="Save"
                      >
                        ✔
                      </button>
                      <button
                        onClick={handleCancel}
                        className="action-btn cancel"
                        title="Cancel"
                      >
                        ✖
                      </button>
                    </div>
                  ) : (
                    <>
                      <button
                        onClick={() => {
                          setEditingId(marker.id);
                          setEditingField("bex_pt_map_X");
                          setEditValue(marker.bex_pt_map_X || "");
                        }}
                        className="action-btn edit"
                        title="Edit"
                      >
                        ✎
                      </button>
                      <button
                        onClick={() =>
                          onDeleteMarker && onDeleteMarker(marker.id)
                        }
                        className="action-btn delete"
                        title="Delete"
                      >
                        🗑
                      </button>
                    </>
                  )}
                </td>
              </tr>
            ))}
          </tbody>
        </table>
      </div>
    </div>
  );
};

export default BecConfXyTable;
